import styled from 'styled-components';
import { Columns } from './GridLayout.props';

const DEFAULT_GAP = 16;
const MOBILE_BREAKPOINT = 968;

export const GridLayoutRoot = styled.div<{
	$columns: Columns;
	$mobileColumns: Columns;
	$gap?: number;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: ${({ $gap }) => $gap !== undefined ? $gap : DEFAULT_GAP}px;
  width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: repeat(${({ $mobileColumns }) => $mobileColumns}, 1fr);
  }
`;
